export const LEGEND_DISPLAY_STYLE = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} as const;
